// extracted by mini-css-extract-plugin
export var dropdownContainer = "_qa-0";
export var leftAlign = "_qa-4";
export var listItem = "_qa-2";
export var listItemWrapper = "_qa-1";
export var operationText = "_qa-3";